import React from 'react';
import classnames from 'classnames';

import classes from './Pricing.scss';

export const PricingOverview = () => (
    <div className={classes.overviewContainer}>
        <div className={classes.overviewTextContainer}>
            <div>
                <h1 className={classes.header}>Workwear Express Pricing Structure at a Glance</h1>
                <p className={classes.textParagraph}>
                    We keep our pricing transparent and straightforward. Every order is made up of three parts:
                </p>

                <p className={classes.textParagraph}>
                    <b>Setup Fee (new logos only):</b> A one-off charge to prepare your artwork so it is ready for
                    embroidery or print.
                </p>
                <p className={classes.textParagraph}>
                    <b>Garment Costs:</b> The price of the clothing or items you choose. Quantity discounts apply, so
                    the more you order of the same item, the lower the price per piece.
                </p>
                <p className={classes.textParagraph}>
                    <b>Application Costs (adding your logo):</b> The fee for applying your design to garments. Each logo
                    counts as one application, and the cost per application reduces as quantities increase.
                </p>

                <p className={classes.textParagraph}>
                    For customers with significant or ongoing demand, we can offer bespoke pricing tailored to your
                    business. Please contact us to discuss your requirements.
                </p>
            </div>
            {/* <div>
                <h2 className={classes.subHeader}>Details on Garment Costs</h2>
                <p className={classes.textParagraph}>
                    We stock a vast range of clothing from various manufacturers, with quantity discounts on all items.
                    On each product page, you'll find a table that indicates the cost depending on the quantity ordered.
                    The discounts apply to the total number of a specific item in your order. Further Information on
                    Application Costs
                </p>

                <p className={classes.textParagraph}>
                    Each printing or embroidery application to an item has an associated cost. This price depends on the
                    total number of applications needed; the more you buy, the cheaper each application becomes. For
                    example, ordering one garment with three printed logos would equate to three printing applications.
                </p>
                <p className={classes.textParagraph}>
                    We are committed to providing top-quality workwear solutions at competitive prices, always aiming to
                    pass on savings where possible. If you have any questions about our pricing, don't hesitate to get
                    in touch.
                </p>
            </div> */}
        </div>

        <img
            className={classnames(classes.overviewImage, classes.imageDesktop)}
            src="../../../static/img/prices1.png"
            alt="Workwear Express pricing"
        />
        <img
            className={classnames(classes.overviewImage, classes.imageMobile)}
            src="../../../static/img/free-returns-img2.png"
            alt="Workwear Express pricing"
        />
    </div>
);
